import '../../styles/main.css';
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Button from '@mui/material/Button';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import { PDFDocument } from 'pdf-lib';

import { TailSpin } from 'react-loader-spinner';
import Colors from '../../library/Colors';

const ShippingPrint = (props) => {
    const [loading, setLoading] = useState(true);
    const [fileUrls, setFileUrls] = useState([]); // Changed to array
    const [pdfDataArray, setPdfDataArray] = useState([]); // Changed to array
    const [rotatedPdfDataArray, setRotatedPdfDataArray] = useState([]); // Changed to array
    const isMobile = props.screenWidth < 600;

    useEffect(() => {
        if (props.selectedPrintOption !== undefined) {
            let receiptNr = 0;
            switch (props.selectedPrintOption) {
                case "shipping":
                    if (props.receiptNr === undefined || props.receiptNr === 0 || props.receiptNr === false) {
                        receiptNr = "man_" + Math.floor(Math.random() * 1000000000);
                    } else {
                        if (typeof props.selectedStore === "undefined" || props.selectedStore === "" || props.selectedStore === false || props.selectedStore === "undefined")
                            receiptNr = props.receiptNr;
                        else
                            receiptNr = props.receiptNr + props.selectedStore;
                    }
                    setLoading(true);
                    createShipment(receiptNr, props.selectedPrintOption);
                    setLoading(false);
                    break;
                case "print":
                    if (props.receiptNr === undefined || props.receiptNr === 0 || props.receiptNr === false) {
                        receiptNr = "man_" + Math.floor(Math.random() * 1000000000);
                    } else {
                        if (typeof props.selectedStore === "undefined" || props.selectedStore === "" || props.selectedStore === false || props.selectedStore === "undefined")
                            receiptNr = props.receiptNr;
                        else
                            receiptNr = props.receiptNr + props.selectedStore;
                    }
                    setLoading(true);
                    createShipment(receiptNr, props.selectedPrintOption);
                    setLoading(false);
                    break;
                default:
                    break;
            }
        }
    }, [props.selectedPrintOption, props.receiptNr]);

    // New effect to process the base64 PDF data
    // Replace the existing useEffect that processes pdfData
    useEffect(() => {
        if (pdfDataArray.length > 0 && isMobile) {
            rotatePdfsForMobile();
        } else if (pdfDataArray.length > 0) {
            // For desktop, just use the original PDF data
            setRotatedPdfDataArray(pdfDataArray);
        }
    }, [pdfDataArray, isMobile]);

    // Effect to handle Ctrl+P keyboard shortcut
    useEffect(() => {
        const handleKeyPress = (event) => {
            // Check if Ctrl+P or Cmd+P (for Mac) is pressed
            if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
                event.preventDefault(); // Prevent default browser print dialog

                // Only proceed if we have PDF data
                if (rotatedPdfDataArray.length > 0) {
                    printLabels();
                }
            }
        };

        // Add event listener
        window.addEventListener('keydown', handleKeyPress);

        // Cleanup
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [rotatedPdfDataArray]);

    // Function to handle printing
    const printLabels = () => {
        rotatedPdfDataArray.forEach((pdfData, index) => {
            // Convert base64 to blob
            const byteCharacters = atob(pdfData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Create blob URL
            const blobUrl = URL.createObjectURL(blob);

            // Open in new window
            const printWindow = window.open(blobUrl, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => {
                        printWindow.print();
                        // Clean up blob URL after printing
                        setTimeout(() => {
                            URL.revokeObjectURL(blobUrl);
                        }, 1000);
                    }, 250);
                };
            }
        });
    };

    // bpost_auto_print kasvar: open the print dialog automatically once the label PDFs are ready.
    // Strict string "1" check: the backend sends "1"/"0" (IF(value='T',...)), while ShippingScreen's
    // initial state is the number 1 — so manual shipments (where fetchSettings flags are never
    // applied) can't accidentally trigger an auto-print.
    const [autoPrinted, setAutoPrinted] = useState(false);
    useEffect(() => {
        if (!autoPrinted && rotatedPdfDataArray.length > 0 && props.showPrintForm === "1" && props.error === '') {
            setAutoPrinted(true);
            printLabels();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rotatedPdfDataArray, props.showPrintForm]);

    // Function to rotate the PDF using the base64 data
    const rotatePdfsForMobile = async () => {
        try {
            setLoading(true);
            const rotatedPdfs = [];

            for (const pdfData of pdfDataArray) {
                // Convert base64 to binary data
                const binaryString = window.atob(pdfData);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // Load the PDF document
                const pdfDoc = await PDFDocument.load(bytes.buffer);

                // Get all pages
                const pages = pdfDoc.getPages();

                // Rotate each page by 90 degrees
                for (const page of pages) {
                    page.setRotation({
                        type: 'degrees',
                        angle: 90,
                    });
                }

                // Save the modified PDF
                const modifiedPdfBytes = await pdfDoc.save();

                // Convert back to base64
                const uint8Array = new Uint8Array(modifiedPdfBytes);
                let base64Output = '';
                uint8Array.forEach(byte => {
                    base64Output += String.fromCharCode(byte);
                });
                const rotatedBase64 = btoa(base64Output);

                rotatedPdfs.push(rotatedBase64);
            }

            setRotatedPdfDataArray(rotatedPdfs);
            setLoading(false);
        } catch (error) {
            console.error('Error rotating PDFs:', error);
            // If rotation fails, use the original data
            setRotatedPdfDataArray(pdfDataArray);
            setLoading(false);
        }
    };

    function createShipment(receiptNr, sendOption) {
        setLoading(true);
        let responseData = '';
        let postData = {
            key: props.api,
            provider: props.shipmentType.shipper + "_" + props.shipmentType.provider,
            shipment_type: props.shipmentOptions.shipment_type,
            shipping_name: props.shipper.name,
            shipping_company: props.shipper.company,
            shipping_street_name: props.shipper.street_name,
            shipping_street_number: props.shipper.house_number,
            shipping_zip: props.shipper.zip,
            shipping_city: props.shipper.city,
            shipping_country: props.shipper.country,
            shipping_email: props.shipper.email,
            shipping_phone: props.shipper.phone,
            parcels: props.shipmentOptions.parcels,
            language: props.lang.toUpperCase(),
            first_name: props.customer.firstname,
            last_name: props.customer.lastname,
            company: props.customer?.company,
            email: props.customer.email,
            street: props.customer.street_name,
            street_number: props.customer.house_number,
            street_number_addition: props.customer.house_number_addition,
            zip: props.customer.zip,
            city: props.customer.city,
            country: props.customer.country,
            // The receiver phone was collected on the customer step but never sent. bpost requires it
            // for "bpack@bpost international" (foreign pickup points) and accepts it for other products.
            phone: props.customer.phone,
            tracking_email: (props.shipmentOptions.tracking_email === "checked" ? true : false),
            second_delivery: (props.shipmentOptions.second_delivery === "checked" ? true : false),
            sameday_delivery: (props.shipmentOptions.sameday_delivery === "checked" ? true : false),
            evening_delivery: (props.shipmentOptions.evening_delivery === "checked" ? true : false),
            basic_insurance: (props.shipmentOptions.basic_insurance === "checked" ? true : false),
            return_label: (props.shipmentOptions.return_label === "checked" ? true : false),
            extra_insurance: props.shipmentOptions.extra_insurance,
            weight: props.shipmentOptions.weight,
            parcelValue: props.shipmentOptions.parcelValue,
            requested_delivery_date: props.shipmentOptions.delivery_date,
            order_id: receiptNr,
            use_remark: false
        };

        if(props.sftAccountId == "37" && props.customer.remark){
            postData.remark = props.customer.remark;
            postData.use_remark = true;
        }

        // Pickup point: BPOST switches the XML to <atBpost>/<at24-7>; MyParcel uses delivery_type 4
        // plus a pickup object built from location_code/retail_network_id.
        if (props.pickupPoint && props.pickupPoint.pickup_id) {
            postData.pickup_id      = props.pickupPoint.pickup_id;
            postData.pickup_type    = props.pickupPoint.pickup_type;
            postData.pickup_name    = props.pickupPoint.pickup_name;
            postData.pickup_street  = props.pickupPoint.pickup_street;
            postData.pickup_number  = props.pickupPoint.pickup_number;
            postData.pickup_zip     = props.pickupPoint.pickup_zip;
            postData.pickup_city    = props.pickupPoint.pickup_city;
            postData.pickup_country = props.pickupPoint.pickup_country || 'BE';
            // MyParcel-specific (present only for MyParcel pickup points).
            if (props.pickupPoint.pickup_location_code !== undefined) {
                postData.pickup_location_code     = props.pickupPoint.pickup_location_code;
                postData.pickup_retail_network_id = props.pickupPoint.pickup_retail_network_id;
                postData.pickup_carrier           = props.pickupPoint.pickup_carrier;
                postData.pickup_cc                = props.pickupPoint.pickup_cc;
            }
        }

        SftGlobalData.post('shipping&action=postOrder', postData).then(response => {
            responseData = response.data;

            // Check if the response status is 200 (success)
            if (response.status == 200) {
                // Handle successful response
                props.setError('');

                // The shipment itself succeeded but the return label could not be created (Sendcloud
                // creates it as a separate parcel). Don't fail the shipment over it — the outbound label
                // is already announced — but make sure it isn't lost silently.
                if (responseData?.return_label_error) {
                    console.warn('[Shipping] Return label was not created:', responseData.return_label_error);
                }

                // Save tracking URL to receipt for MyParcel shipments only
                const isMyParcel = props.shipmentType?.shipper?.toLowerCase().includes('myparcel');
                const shipmentId = responseData?.id; // tracking_id is actually the shipment_id
                const isRealReceipt = receiptNr && !receiptNr.toString().startsWith('man_');

                // Resolve the real tracking number + URL for every MyParcel shipment, including manual
                // (man_) ones — the log row is updated by shipment_id (no kasticket needed). Only pass a
                // receiptNr for real receipts so the kasticket write targets a real ticket; manual
                // shipments have no kasticket and correctly skip it (empty receiptNr).
                if (isMyParcel && shipmentId) {
                    // Extract platform from provider (e.g., "myparcel_be" -> "be")
                    const platform ='be';

                    if (SftGlobalData.debug) {
                        console.log('[Shipping] Fetching MyParcel tracking URL:', {
                            shipmentId: shipmentId,
                            platform: platform
                        });
                    }

                    // Fetch the actual tracking URL from MyParcel (with delay to allow processing)
                    setTimeout(() => {
                        SftGlobalData.post('shipping&action=getMyParcelTracking', {
                            key: props.api,
                            shipment_id: shipmentId,
                            platform: platform,
                            receiptNr: isRealReceipt ? receiptNr?.toString().replace(/[A-Z]+$/, '').substring(0, 10) : ''
                        }).then(trackingResponse => {

 
                        }).catch(trackingError => {
                            console.error('[Shipping] Failed to fetch MyParcel tracking:', trackingError);
                            // Don't show error to user - this is a background operation
                        });
                    }, 1000); // 1 second delay to allow MyParcel to process the shipment
                }

                if (sendOption === "print" && props.api !== '') {
                    let postData = {
                        key: props.api,
                        provider: props.shipmentType.shipper + "_" + props.shipmentType.provider,
                        print_return_label: (props.shipmentOptions.return_label === "checked" ? true : false),
                        order_id: receiptNr,
                        label_type: (typeof props.shipmentOptions?.paper_size !== "undefined" ? props.shipmentOptions.paper_size : "A6")
                    };

                    SftGlobalData.post('shipping&action=fetchLabel', postData).then(response => {
                        responseData = response.data;

                        if (response.status === 200) {
                            if (responseData["url"] && responseData["url"].includes(';')) {
                                // Multiple URLs
                                setFileUrls(responseData["url"].split(';'));
                            } else {
                                // Single URL
                                setFileUrls([responseData["url"]]);
                            }

                            const pdfs = [];
                            if (responseData["pdf"]) {
                                pdfs.push(responseData["pdf"]);
                            }
                            if (responseData["return_pdf"]) {
                                pdfs.push(responseData["return_pdf"]);
                            }
                            setPdfDataArray(pdfs);
                        } else {
                            // Handle error in fetchLabel
                            props.setError(responseData["message"] || 'Failed to fetch label');
                        }
                    }).catch(error => {
                        if (SftGlobalData.debug) {
                            console.error("Error fetching label:", error);
                        }
                        props.setError('Failed to fetch shipping label');
                    });
                }
            } else {
                // Handle error response - error is directly in response.message
                props.setError(response.message || 'An error occurred while creating the shipment');
            }
        }).catch(error => {
            // Handle network or other errors. Prefer the backend's error message (e.g. a Sendcloud
            // validation error like "postal_code: Enter a valid zip code.") over a generic fallback.
            console.error("Error creating shipment:", error);
            props.setError(error?.response?.data?.message || 'Network error: Unable to create shipment');
        });
    }

    function showBackButton() {
        // Existing code unchanged
        if (props.error !== '') {
            return <div>
                {props.screenWidth >= 600 && <Button variant="contained" className={'button_container__button width_140px align_left'} onClick={() => { props.switchForm(false); }}>{props.t('back')}</Button>}
                {props.screenWidth < 600 && <h2 className={(props.theme === 'dark') ? "dark " : "light margin_bottom_none "} style={{ textAlign: 'center', width: '100%' }}>{props.t('titleShippingConfirmation')}</h2>}
                {props.screenWidth >= 600 && <h2 className={(props.theme === 'dark') ? "dark container_list__title  detail" : "light container_list__title margin_bottom_none detail"} type="text" id="list_name" name="listName">{props.t('titleShippingConfirmation')}</h2>}
                {props.screenWidth < 600 && <div className="margin_bottom_10px"></div>}
                {props.screenWidth < 600 && <Button variant="contained" className={'button_container__button width_140px align_left'} onClick={() => { props.switchForm(false); }}>{props.t('back')}</Button>}

            </div>
        } else if (props.hideSidebar === false) {
            return <div>
                {props.screenWidth >= 600 && <Link to={"/" + props.lang + "/shipping"}>
                    <Button type="button" className="button_container__button  align_left width_140px">{props.t('shippingLog')}</Button>
                </Link>}

                {props.screenWidth < 600 && <h2 className={(props.theme === 'dark') ? "dark " : "light margin_bottom_none "} style={{ textAlign: 'center', width: '100%' }}>{props.t('titleShippingConfirmation')}</h2>}
                {props.screenWidth >= 600 && <h2 className={(props.theme === 'dark') ? "dark container_list__title  detail" : "light container_list__title margin_bottom_none detail"} type="text" id="list_name" name="listName">{props.t('titleShippingConfirmation')}</h2>}
                {props.screenWidth < 600 && <div><Link to={"/" + props.lang + "/shipping"}>
                    <Button type="button" className="button_container__button  align_left _100perc">{props.t('shippingLog')}</Button>
                </Link></div>}
            </div>
        } else {
            return <div>
                <h2 className={(props.theme === 'dark') ? "dark container_list__title" : "light container_list__title"}
                    type="text"
                    id="list_name"
                    name="listName">{props.t('titleShippingConfirmation')}</h2>
            </div>
        }
    }

    return (
        <div style={{ padding: 5 }} className='shipping'>
            <div className="container_list__title">
                {showBackButton()}
            </div>

            {loading &&
                <div className={"container_list__title " + props.theme}
                    style={{ display: "flex", justifyContent: "space-evenly", marginTop: 5, border: 1 }}>
                    <TailSpin
                        height="40"
                        width="40"
                        color={Colors.sft_blue}
                        ariaLabel='loading'
                    />
                </div>
            }

            {!loading &&
                <div className="app-content shipping">
                    {props.error === '' ?
                        (rotatedPdfDataArray.length > 0 ?
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px',
                                width: '100%',
                                alignItems: 'center'
                            }}>
                                {rotatedPdfDataArray.length > 1 && (
                                    <div style={{
                                        width: '100%',
                                        maxWidth: (props.screenWidth < 600 ? '100%' : 600),
                                        padding: '10px 14px',
                                        borderRadius: '6px',
                                        backgroundColor: '#fff3cd',
                                        color: '#664d03',
                                        border: '1px solid #ffe69c',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>
                                        ⬇ {props.t('multipleLabelsNotice', { count: rotatedPdfDataArray.length })}
                                    </div>
                                )}
                                {rotatedPdfDataArray.map((pdfData, index) => (
                                    <div key={index}>
                                        {rotatedPdfDataArray.length > 1 && (
                                            <h3 style={{ marginBottom: '10px' }}>
                                                {index === 0 ? props.t('mainLabel') || 'Main Label' : props.t('returnLabel') || 'Return Label'}
                                            </h3>
                                        )}
                                        <div style={{
                                            width: (props.screenWidth < 600 ? '100%' : 600),
                                            height: '500px',
                                            overflow: 'hidden',
                                            position: 'relative'
                                        }}>
                                            <iframe
                                                src={`data:application/pdf;base64,${pdfData}`}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none'
                                                }}
                                                title={`Shipping Label ${index + 1}`}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : "Label succesvol aangemaakt")
                        : props.error
                    }
                </div>
            }
        </div>
    );
}

export default ShippingPrint;